var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHandHeart(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.05 21.383h4.07c1.018 0 1.842-.82 1.842-1.832a1.837 1.837 0 00-1.841-1.832h-5.108a6.681 6.681 0 00-3.392-.916c-3.157 0-5.794 2.166-6.433 5.056M9.88 26.71l.102-.076c.217-.162.418-.345.628-.515a4.043 4.043 0 012.547-.902h7.54a4.04 4.04 0 002.85-1.174l5.87-5.838a1.976 1.976 0 000-2.805 2.002 2.002 0 00-2.82 0l-4.634 4.608M9.88 26.711L5.313 22.17a1.618 1.618 0 00-2.28 0L1 24.191 7.845 31l2.034-2.023c.63-.625.63-1.64 0-2.266zm6.599-12.028s-7.452-4.354-7.452-9.64c0-.935.31-1.84.878-2.563A3.85 3.85 0 0112.14 1.08a3.735 3.735 0 012.581.394 3.986 3.986 0 011.757 2.012 3.986 3.986 0 011.757-2.012 3.735 3.735 0 012.58-.394 3.85 3.85 0 012.237 1.401c.568.723.878 1.628.878 2.563 0 5.286-7.452 9.64-7.452 9.64z",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgHandHeart;